import { setCookie } from 'modules/persistence';
import request from 'superagent';

import { getCsrfToken } from '../../utils';
import {
    CHANGE_TO_EDIT_VIEW,
    CHANGE_TO_INTERVIEW_EDIT_VIEW,
    CHANGE_TO_TRANSLATIONS_VIEW,
    CLEAR_VIEW_MODES,
    MERGE_TRANSLATIONS,
    RECEIVE_RESULT,
    REQUEST_TRANSLATIONS,
    SET_ARCHIVE_ID,
    SET_AVAILABLE_VIEW_MODES,
    SET_LOCALE,
    SET_PROJECT_ID,
    SET_SELECTED_ARCHIVE_IDS,
    SET_VIEW_MODE,
    UPDATE_SELECTED_ARCHIVE_IDS,
    UPDATE_SELECTED_REGISTRY_ENTRY_IDS,
} from './action-types';

export const setLocale = (locale) => ({
    type: SET_LOCALE,
    locale: locale,
});

export const setArchiveId = (archiveId) => ({
    type: SET_ARCHIVE_ID,
    archiveId: archiveId,
});

export const setProjectId = (projectId) => ({
    type: SET_PROJECT_ID,
    projectId: projectId,
});

export const setAvailableViewModes = (viewModes) => ({
    type: SET_AVAILABLE_VIEW_MODES,
    payload: viewModes,
});

export const setViewMode = (viewMode) => ({
    type: SET_VIEW_MODE,
    payload: viewMode,
});

export const clearViewModes = () => ({
    type: CLEAR_VIEW_MODES,
});

const editView = (bool) => ({
    type: CHANGE_TO_EDIT_VIEW,
    editView: bool,
});

export function changeToEditView(bool) {
    return (dispatch) => {
        dispatch(editView(bool));
        // remove cookie through negative expiration time:
        let expireDays = bool ? 3 : -1;
        setCookie('editView', bool, expireDays);
    };
}

const translationsView = (bool) => ({
    type: CHANGE_TO_TRANSLATIONS_VIEW,
    translationsView: bool,
});

export function changeToTranslationsView(bool) {
    return (dispatch) => {
        dispatch(translationsView(bool));
        // remove cookie through negative expiration time:
        let expireDays = bool ? 3 : -1;
        setCookie('translationsView', bool, expireDays);
    };
}

const interviewEditView = (bool) => ({
    type: CHANGE_TO_INTERVIEW_EDIT_VIEW,
    interviewEditView: bool,
});

export function changeToInterviewEditView(bool) {
    return (dispatch) => {
        dispatch(interviewEditView(bool));
        // remove cookie through negative expiration time:
        let expireDays = bool ? 3 : -1;
        setCookie('interviewEditView', bool, expireDays);
    };
}

const receiveResult = (result) => ({
    type: RECEIVE_RESULT,
    result: result,
});

export function submitSelectedArchiveIds(
    archiveIds,
    action,
    pathBase,
    filename,
    format
) {
    return (dispatch) => {
        if (filename) {
            // Dynamically create and submit a form to trigger file download with POST parameters
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = `${pathBase}/interviews/${action}.${format}`;
            form.style.display = 'none';

            archiveIds.forEach((archiveId) => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = 'archive_ids[]';
                input.value = archiveId;
                form.appendChild(input);
            });

            // Include CSRF token for Rails authenticity protection
            const csrfToken = document
                .querySelector('meta[name="csrf-token"]')
                ?.getAttribute('content');
            if (csrfToken) {
                const csrfInput = document.createElement('input');
                csrfInput.type = 'hidden';
                csrfInput.name = 'authenticity_token';
                csrfInput.value = csrfToken;
                form.appendChild(csrfInput);
            }

            document.body.appendChild(form);
            form.submit();
            form.parentNode.removeChild(form);
        } else {
            request
                .post(`${pathBase}/interviews/${action}`)
                .send({ archive_ids: archiveIds })
                .set('Accept', 'application/json')
                .set('X-CSRF-Token', getCsrfToken())
                .then((res) => {
                    if (res) {
                        dispatch(receiveResult(JSON.parse(res.text)));
                    }
                });
        }
    };
}

const updateSelectedArchiveIds = (archiveId) => ({
    type: UPDATE_SELECTED_ARCHIVE_IDS,
    archiveId: archiveId,
});

export function addRemoveArchiveId(archiveId) {
    return (dispatch) => {
        dispatch(updateSelectedArchiveIds(archiveId));
    };
}

const updateSelectedRegistryEntryIds = (rid) => ({
    type: UPDATE_SELECTED_REGISTRY_ENTRY_IDS,
    rid: rid,
});

export function addRemoveRegistryEntryId(rid) {
    return (dispatch) => {
        dispatch(updateSelectedRegistryEntryIds(rid));
    };
}

const setSelectedArchiveIds = (archiveIds) => ({
    type: SET_SELECTED_ARCHIVE_IDS,
    archiveIds: archiveIds,
});

export function setArchiveIds(archiveIds) {
    return (dispatch) => {
        dispatch(setSelectedArchiveIds(archiveIds));
    };
}

const mergeTranslations = (translations) => ({
    type: MERGE_TRANSLATIONS,
    translations: translations,
});

const requestTranslations = () => ({
    type: REQUEST_TRANSLATIONS,
});

export function fetchTranslationsForLocale(locale, pathBase) {
    return (dispatch, getState) => {
        // Check if we already have translations for this locale
        const currentState = getState();
        const existingTranslations = currentState.archive.translations || {};

        // Check if we already have some translations for this locale
        const hasTranslationsForLocale = Object.keys(existingTranslations).some(
            (key) =>
                existingTranslations[key] && existingTranslations[key][locale]
        );

        // If we already have translations for this locale, don't fetch again
        if (hasTranslationsForLocale) {
            return Promise.resolve();
        }

        dispatch(requestTranslations());

        // Build the API endpoint (prefer explicit pathBase when provided)
        const url = `${pathBase}/translation_strings.json`;

        return request
            .get(url)
            .then((response) => {
                dispatch(mergeTranslations(response.body.translations || {}));
            })
            .catch((error) => {
                console.error('Failed to fetch translations:', error);
                // Don't dispatch anything on error to keep existing translations
            });
    };
}

export function registerDoi(pathBase, dataType, id) {
    return (dispatch) => {
        request
            .post(`${pathBase}/${dataType}/${id}/doi`)
            //.send({})
            .set('Accept', 'application/json')
            .set('X-CSRF-Token', getCsrfToken())
            .then((res) => {
                if (res) {
                    dispatch(receiveResult(JSON.parse(res.text)));
                }
            });
    };
}
